import React from "react";

export default class About extends React.Component {
  render() {
    return (
      <div className="section clearfix translucent-bg-nichesoft nichesoft-watermark-img">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <h1
                id="privacypolicy"
                className="title text-center"
                style={{ marginTop: "4.5%" }}
              >
                <span>Privacy Policy</span>
              </h1>
              <div className="lead text-left" style={{ fontFamily: "inherit" }}>
                <p style={{ fontSize: 17 }}>
                  <b>
                    1. What personal information do we collect from the people
                    that visit our Facebook Home page or website ?
                  </b>
                  <br />
                  We collect your Facebook basic profile information ( id, name,
                  first name, last name, and profile pic fields for user's that
                  have made this information public). [When ordering or
                  registering on our site, as appropriate, you may be asked to
                  enter your name, email address or other details to help you
                  with your experience.]
                  <br />
                  <br />
                  <b>2. When do we collect information?</b>
                  <br />
                  We collect this information only when you start a conversation
                  with us in the messenger. [We collect information from you
                  when you register on our site or enter information on our
                  site.]
                  <br />
                  <br />
                  <b>3. How do we use your information?</b>
                  <br />
                  We may use the information to contact you when we have
                  suitable job openings or service offerings.
                  <br />
                  <br />
                  <b>4. How do we protect visitor information?</b>
                  <br />
                  Your personal information is contained behind secured networks
                  and is only accessible by a limited number of persons who have
                  special access rights to such systems, and are required to
                  keep the information confidential. In addition, all
                  sensitive/credit information you supply is encrypted via
                  Secure Socket Layer (SSL) technology.
                  <br />
                  <br />
                  <b>5. Do we use 'cookies'?</b>
                  <br />
                  No, we don't use Cookies
                  <br />
                  <br />
                  <b>6. Third-party disclosure</b>
                  <br />
                  We do not sell, trade, or otherwise transfer to outside
                  parties your personally identifiable information. We may
                  release information when it's release is appropriate to comply
                  with the law, enforce our site policies, or protect ours or
                  others' rights, property, or safety.
                  <br />
                  <br />
                  <b>7. Third-party links</b>
                  <br />
                  We don't include or offer third-party products or services on
                  our website. . Once this privacy policy is created, we will
                  add a link to it on our home page or as a minimum on the first
                  significant page after entering our website. Our Privacy
                  Policy link includes the word 'Privacy' and can be easily be
                  found on the page specified above. Users will be notified of
                  any privacy policy changes: On our Privacy Policy Page
                  <br />
                  <br />
                  <b>8. How does our site handle do not track signals?</b>
                  <br />
                  We honor do not track signals and do not track, plant cookies,
                  or use advertising when a Do Not Track (DNT) browser mechanism
                  is in place.
                  <br />
                  <br />
                  <b>9. Does our site allow third-party behavioral tracking?</b>
                  <br />
                  No
                  <br />
                  <br />
                  <b>10. COPPA (Children Online Privacy Protection Act)</b>
                  <br />
                  We strictly do not allow or entertain collection of personal
                  information from children under 13
                  <br />
                  <br />
                  <b>11. Fair Information Practices</b>
                  <br />
                  The Fair Information Practices Principles form the backbone of
                  privacy law in the United States and the concepts they include
                  have played a significant role in the development of data
                  protection laws around the globe. Understanding the Fair
                  Information Practice Principles and how they should be
                  implemented is critical to comply with the various privacy
                  laws that protect personal information. In order to be in line
                  with Fair Information Practices we will take the following
                  responsive action, should a data breach occur: We will notify
                  the users via email within 7 business days. We also agree to
                  the Individual Redress Principle, which requires that
                  individuals have a right to pursue legally enforceable rights
                  against data collectors and processors who fail to adhere to
                  the law. This principle requires not only that individuals
                  have enforceable rights against data users, but also that
                  individuals have recourse to courts or government agencies to
                  investigate and/or prosecute non-compliance by data
                  processors.
                  <br />
                  <br />
                  <b>12. CAN SPAM Act</b>
                  <br />
                  The CAN-SPAM Act is a law that sets the rules for commercial
                  email, establishes requirements for commercial messages, gives
                  recipients the right to have emails stopped from being sent to
                  them, and spells out tough penalties for violations. We
                  collect your email address in order to: To be in accordance
                  with CANSPAM we agree to the following: If at any time you
                  would like to unsubscribe from receiving future emails, you
                  can email us at and we will promptly remove you from ALL
                  correspondence.
                  <br />
                  <br />
                  <b>13. Contacting Us</b>
                  <br />
                  If there are any questions regarding this privacy policy you
                  may contact us using the information below or send mail at
                  sales@nichesolv.com
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/privacyPolicy/index.js